const initMediaWithTooltips = () => {
	const initMediaWithTooltipsComponent = document.querySelectorAll(
		"section.media-with-tooltips"
	);

	if (!initMediaWithTooltipsComponent.length) {
		return;
	}

	initMediaWithTooltipsComponent.forEach((component) => {
		new Swiper(component.querySelector(".swiper"), {
			slidesPerView: 1,
			loop: true,
			navigation: {
				nextEl: ".button-next",
				prevEl: ".button-prev",
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
		});
	});
};

export { initMediaWithTooltips };
